import _Object$setPrototypeOf from "core-js/library/fn/object/set-prototype-of.js";
export default function _setPrototypeOf(o, p) {
  _setPrototypeOf = _Object$setPrototypeOf ? _Object$setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs2/helpers/esm/setPrototypeOf.js
// module id = null
// module chunks = 